import React from "react";
import { Download } from "lucide-react";
import Button from "components/button";
import ViewButton from "components/button/viewbutton";
import DocumentInfo from "views/console/team-managements/employee-details/components/DocumentInfo";

const DocumentCard = ({
    title,
    description,
    status,
    date,
    size,
    icon,
    documentData,
    onDownload,
}) => {

   const statusText = status ? String(status) : "Active";
    const statusClass = statusText.toLowerCase().replace(/\s+/g, "-");

    return (
        <>
            <div className="bg-white flex flex-col gap-6 rounded-xl border hover:shadow-md border-slate-200 dark-mode-card">
                <div className="p-4 pb-6">
                    <div className="flex items-start gap-4">
                    <div className="p-3 rounded-lg bg-slate-50 border border-slate-200">
                        {icon}
                    </div>

                    <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2 mb-2">
                            <h4 className="font-semibold text-[14px] title-text">{title}</h4>
                            <span className={`status-docs ${statusClass}`}>
                                {statusText}
                            </span>

                            </div>
                            <p className="text-[12px] mb-3 muted-text">
                                {description}
                            </p>

                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4 text-[11px] muted-text">
                                    <span>{date}</span>
                                    <span>•</span>
                                    <span>{size}</span>
                                </div>

                                <div className="flex items-center gap-2">
                                    <ViewButton>
                                        <DocumentInfo document={documentData} />
                                    </ViewButton>
                                    <Button
                                        onClick={onDownload}
                                        className="inline-flex items-center justify-center font-medium border hover:bg-slate-50 hover:shadow-none rounded-lg gap-1.5 h-8 px-3 text-[12px]"
                                    >
                                        <Download className="w-3 h-3 mr-1" />
                                        <span>Download</span>
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentCard;
